export default "__VITE_ASSET__C6G0__wP__"